export const InviteStatuses = {
  awaiting: 'awaiting',
  ableToInvite: 'ableToInvite',
  invitedRefused: 'invitedRefused',
  connected: 'connected',
};
